function openDialog(options) {
    return new Promise(resolve => {
        window.dispatchEvent(new CustomEvent('nido:dialog', {
            detail: { ...options, resolve },
        }));
    });
}

export default {
    install(app) {
        app.config.globalProperties.$alert = options => openDialog({
            kind: 'alert',
            ...(typeof options === 'string' ? { message: options } : options),
        });
        app.config.globalProperties.$confirm = options => openDialog({
            kind: 'confirm',
            ...(typeof options === 'string' ? { message: options } : options),
        });
        app.config.globalProperties.$prompt = options => openDialog({
            kind: 'prompt',
            ...(typeof options === 'string' ? { message: options } : options),
        });
    },
};
